module.exports = "/_next/static/images/fe28066d8ef37cf1778b26d7b4e027b0-boy-looking-to-the-front-lg@1x.jpg.webp";